// extracted by mini-css-extract-plugin
export default {"root":"ShortNewsContentPart_root__3Uf5G","folgBat":"ShortNewsContentPart_folgBat__2UJSX"};